import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const BeschreibungenAbschlussEmob: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title="Beschreibung" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default BeschreibungenAbschlussEmob;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Elektro_0133067591_ektromobilitaet_Beschreibung,
				P.Abschlussbericht_Elektro_0068550071_tlichen_Effekte_Beschreibung,
				P.Abschlussbericht_Elektro_0013062855_ebertragbarkeit_Beschreibung,
				P.Abschlussbericht_Elektro_0157552279_egleitforschung_Beschreibung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBeschreibungenAbschlussEmob = () => {
	let result = concat(formStruc());
	return result;
};
